import { Spinner } from "components/Spinner";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import ProgressBar from "ds/components/ProgressBar";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type RunsLoadingProgressProps = {
  loaded: number;
  total?: number;
};

const RunsLoadingProgress = ({ loaded, total }: RunsLoadingProgressProps) => (
  <Box direction="column" align="start" gap="x-large" fullWidth>
    <Box align="center" gap="medium" padding="medium large" className={styles.card}>
      <Typography tag="span" variant="p-body3">
        Loaded runs
      </Typography>
      {total !== undefined && (
        <ProgressBar current={loaded} max={total} ariaLabel="Runs loading progress" />
      )}
      {total === undefined && (
        <Typography tag="span" variant="p-t7">
          {loaded}
        </Typography>
      )}
      <Icon src={Spinner} />
    </Box>
    <Box justify="center" align="center" padding="xx-large" fullWidth>
      <Typography tag="p" variant="p-body2">
        Please wait while we load the data…
      </Typography>
    </Box>
  </Box>
);

export default RunsLoadingProgress;
